import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import CostDetailRow from './CostDetailRow';
import {
  fetchPaymentTypeList,
  fetchPaymentList,
  tryAddPayment,
  tryUpdateTotalPrice
} from 'actions/PaymentActions';

class ConstructionCostModal extends Component {
  constructor(props) {
    super(props);

    this.initState = {
      selectedType: 0,
      typeError: false,
      newAmount: 0,
      amountError: false,
      newNotes: "",
      notesError: false,
      newTotalPrice: 0,
      editingTotalPrice: false,
      updatingTotalPrice: false,
      totalPriceError: false,
    }

    this.state = this.initState;
  }

  componentDidMount() {
    let {dispatch, workOn} = this.props;

    dispatch(fetchPaymentTypeList());
    dispatch(fetchPaymentList(workOn));
  }

  switchPaymentType = (e) => {
    this.setState({selectedType: e.target.value, typeError: false})
  }

  validAmount = (amount) => {
    return amount <= 0
  }

  handleAmountChange = (e) => {
    let val = e.target.value;
    this.setState({newAmount: val, amountError: this.validAmount(val)})
  }

  validNotes = (notes) => {
    return notes.length > 45
  }

  handleNoteChange = (e) => {
    let val = e.target.value;
    this.setState({newNotes: val, notesError: this.validNotes(val)})
  }

  handleAdd = () => {
    let {dispatch, workOn} = this.props;
    let {selectedType, newAmount, newNotes} = this.state;
    let inValidType = selectedType <= 0;
    let inValidAmount = this.validAmount(newAmount);
    let inValidNotes = this.validNotes(newNotes);

    if (inValidType || inValidAmount || inValidNotes) {
      this.setState({typeError: inValidType, amountError: inValidAmount, notesError: inValidNotes})
    } else {
      this.setState(this.initState);
      dispatch(tryAddPayment(workOn, selectedType, parseInt(newAmount, 10), newNotes));
    }

  }


  validTotalPrice = (totalPrice) => {
    return totalPrice == ""
  }

  handleTotalPriceChange = (e) => {
    let val = e.target.value;
    this.setState({newTotalPrice: val, editingTotalPrice: val != this.state.totalPrice});
  }

  handleUpdateTotalPrice = () => {
    let {dispatch, workOn} = this.props;
    let {newTotalPrice} = this.state;

    let inValidTotalPrice = this.validTotalPrice(newTotalPrice);
    this.setState({totalPriceError: inValidTotalPrice});
    if (inValidTotalPrice) {
      return 
    }
    this.setState({updatingTotalPrice: true});
    dispatch(tryUpdateTotalPrice(workOn, newTotalPrice))
      .then(() => {
        this.setState({updatingTotalPrice: false, editingTotalPrice: false});
      })
      
  }

  render() {
    let {constructionName, labourPayment, paymentList, handleDisMissModal, totalPrice} = this.props;
    let {selectedType, typeError, newAmount, amountError, newNotes, notesError, newTotalPrice, editingTotalPrice, totalPriceError, updatingTotalPrice} = this.state;

    const LabourTable = ({labourPayment}) => {
      let total = 0;
      let totalWorkUnit = 0;
      return (
        <table className="table table-hover cost-table">
          <thead>
            <tr className="table-header">
              <th colSpan={3}>
                <span className="glyphicon glyphicon-user"/> 勞動力
              </th>
            </tr>
            <tr className="table-sub-header">
              <th>職位</th>
              <th>工數</th>
              <th>花費</th>
            </tr>
          </thead>
          <tbody>
            {labourPayment.map(labour => {
              let amonunt = labour.get('amount');
              let workUnit = labour.get('workUnit');
              let notes = labour.get('notes');

              total += amonunt;
              totalWorkUnit += workUnit;
              return (
                <tr className="table-labour-cost-detail">
                  <td>{notes}</td>
                  <td>{workUnit}</td>
                  <td>${amonunt}</td>
                </tr>
              )
            })}
            <tr className="table-cost-total">
              <td>勞動力總開支：</td>
              <td>{totalWorkUnit}工</td>
              <td>${total}</td>
            </tr>
          </tbody>
        </table>
      )
    }

    const PaymentTable = ({paymentList}) => (
      <div>
        <table className="table table-hover cost-table">
          <thead>
            <tr className="table-header">
              <th colSpan={2}>
                <span className="glyphicon glyphicon-list-alt"/> 其他開支
              </th>
            </tr>
          </thead> 
        </table>
        {paymentList.map((paymentCate) => {
          let cate = paymentCate.get('type');
          let payments = paymentCate.get('payments');
          let total = 0;
           
          return payments.size > 0 && (
            <table className="table table-hover cost-table">
              <thead>
                <tr className="table-cost-category">
                  <th colSpan={2}>{cate}</th>
                </tr>
                <tr className="table-sub-header">
                  <th>說明</th>
                  <th>花費</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => {
                  let id = payment.get('id');
                  let amount = payment.get('amount');
                  let notes = payment.get('notes');
                
                  total += amount;
                  return (               
                    <CostDetailRow
                      id={id}
                      amount={amount}
                      notes={notes}
                      workOn={this.props.workOn}
                      cate={cate}
                      validAmount={this.validAmount}
                      validNotes={this.validNotes}
                      dispatch={this.props.dispatch} />
                  )
                })}
                <tr className="table-cost-total">
                  <td>{cate}總開支：</td>
                  <td>${Math.round(total * 10) / 10}</td>
                </tr>
              </tbody>
            </table>
          )
        })}
      </div>
    )
    
    const labourPaymentTotal = labourPayment.reduce(
      (s, labour) => s + labour.get('amount'),
    0);
    const otherPaymentTotal = paymentList.reduce(
      (s, payments) => s + payments.get('payments').reduce((s, p) => s + p.get('amount'), 0), 
    0);
    
    return (
      <Modal.Dialog className="construction-cost-modal">
        <Modal.Header>
          <Modal.Title>
           {constructionName} - 開支詳細
          <span 
            className="btn btn-danger btn-xs dismiss-btn glyphicon glyphicon-remove"
            onClick={handleDisMissModal}>
          </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LabourTable labourPayment={labourPayment} />
          {paymentList.size > 0 && <PaymentTable paymentList={paymentList} />}
        </Modal.Body>
        <Modal.Footer>
          <div className="form-inline add-payment-form">
            <div className={"input-group type-group" + (typeError? " has-error" : "")}>
              <select className="form-control type" value={selectedType} onChange={this.switchPaymentType}>
                <option disabled>類別</option>
                {this.props.paymentType.map(type=>(
                  <option key={type.get('id')} value={type.get('id')}>{type.get('name')}</option>
                ))}
              </select>
            </div>
            <div className={"input-group amount-group" + (amountError? " has-error" : "")}>
              <span className="input-group-addon">$</span>
              <input 
                type="number" 
                placeholder="花費" 
                className="form-control amount"
                value={newAmount} 
                onChange={this.handleAmountChange} />
            </div>
            <div className={"form-group notes-group" + (notesError? " has-error" : "")}>
              <input 
                type="text" 
                placeholder="說明" 
                className="form-control notes" 
                value={newNotes}
                onChange={this.handleNoteChange} />
            </div>
            <button
              className="btn btn-default"
              onClick={this.handleAdd}>
              新增開支
            </button>
          </div>
        </Modal.Footer>
        <Modal.Footer>
          <div className="form-inline total-price-form">
            <div className={"form-group" + (totalPriceError ? " has-error" : "")}>
              <div className="input-group">
                <span className="input-group-addon">總價</span>
                <input 
                  type="text"
                  className={"form-control"}
                  placeholder="填寫總價" 
                  value={editingTotalPrice ? newTotalPrice : totalPrice}
                  onChange={this.handleTotalPriceChange}
                  disabled={updatingTotalPrice}
                />
                <span className="input-group-btn">
                  <button 
                    className={"btn btn-default" + (!editingTotalPrice || updatingTotalPrice ? " disabled": "")} 
                    type="button"
                    onClick={this.handleUpdateTotalPrice}
                  >更新</button>
                </span>
              </div>
            </div>

            <div className="form-group profit-group">
              <label>利潤: ${totalPrice - labourPaymentTotal - otherPaymentTotal}</label>
            </div>
          </div>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }

}

export default ConstructionCostModal;


// WEBPACK FOOTER //
// ./src/components/Construction/ConstructionCostModal.js